<template>
  <v-row justify="center">
    <template>
      <v-btn v-if="userOp.role!='operateur'" color="secondary" dark @click="openDialog()" rounded>
        <v-icon left dark>mdi-plus-circle-outline</v-icon> Projets
      </v-btn>
    </template>
    <v-chip
      v-for="(projet, index) in projetsSelected"
      :key="index"
      class="ma-2"
      label
    >
      {{ projet.ll_programme }}
    </v-chip>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="headline">
          Projets de {{ user.displayName }}
        </v-card-title>
        <v-card-text>
          <template>
            <v-card class="mx-auto elevation-0">
              <template>
                <v-container fluid>
                  <v-row align="center">
                    <v-col cols="12">
                      <v-select
                        ref="projetsSelectedRef"
                        v-model="projetsSelected"
                        :items="projets"
                        label="Selectionnez les projets"
                        multiple
                        persistent-hint
                        item-text="ll_programme"
                        return-object
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
            </v-card>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" dark @click="dialog = false" rounded>
            Annuler
          </v-btn>
          <v-btn
            color="green darken-1"
            dark
            @click="addProjectToUser"
            rounded
            :loading="saveloading"
          >
            Sauvegarder
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {},
  props: {
    user: {
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      projetsSelected: Array.isArray(this.user.projets) ? this.user.projets : [],
      saveloading: false,
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    fusionProjets(projets) {
      let self = this;
      const userProjets = this.user.projets;
      const listeProjets = this.projets;
      const userProjetsArray = [];
      const newProjets = [];
      _.forEach(userProjets, function (item, index) {
        userProjetsArray[index] = item.id_programme;
      });

      /* _.forEach(listeProjets, function (item, index) {
        if (_.includes(userProjetsArray, item.id)) {
          item.checked = true;
          console.log("misy", item.ll_programme);
        }

        newProjets.push(item);
      }); */

      return _.union(userProjets, listeProjets);
    },

    addProjectToUser() {
      let self = this;
      this.saveloading = true;
      let projetsSelectednew = [];
      _.forEach(this.projetsSelected, function (item) {
        projetsSelectednew.push({
          ...item,
          id_programme: item.id,
          id: item.id,
        });
      });
      //console.log(projetsSelectednew);

      var usersRef = this.$firebase
        .firestore()
        .collection("users")
        .doc(this.user.id);
      if (projetsSelectednew.length > 0) {
        usersRef
          .set(
            {
              projets: projetsSelectednew,
            },
            { merge: true }
          )
          .then(function () {
            console.log("Document successfully written!");
            self.projetsSelected = projetsSelectednew;
            self.GetIdentifiantsAll();
            self.saveloading = false;
            self.dialog = false;
          })
          .catch(function (error) {
            console.error("Error writing document: ", error);
          });
      } else {
        console.log("tableau vide");
        usersRef
          .set({ projets: [] }, { merge: true })
          .then(function () {
            console.log("Document successfully updated!");
            self.GetIdentifiantsAll();
            self.saveloading = false;
            self.dialog = false;
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
          });
      }
    },

    ...mapActions({
      GetAllProjects: "Projets/getListeProjets",
      GetIdentifiantsAll: "Users/getAll",
    }),
  },
  computed: {
    ...mapState({
      projets: (state) => state.Projets.projets,
      AdminNavigation: (state) => state.Navigation.AdminNavigation,
      userOp: (state) => state.Auth.user,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
